"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT_SCREEN = exports.INIT_SCREEN = "INIT_SCREEN";
var UNMOUNT_SCREEN = exports.UNMOUNT_SCREEN = "UNMOUNT_SCREEN";
var HANDLE_SCREEN_CONFIGURATION_FIELD_CHANGE = exports.HANDLE_SCREEN_CONFIGURATION_FIELD_CHANGE = "HANDLE_SCREEN_CONFIGURATION_FIELD_CHANGE";
var PREPARE_FINAL_OBJECT = exports.PREPARE_FINAL_OBJECT = "PREPARE_FINAL_OBJECT";
var FORM_SUBMIT = exports.FORM_SUBMIT = "FORM_SUBMIT";
var SHOW_NEW_TOAST = exports.SHOW_NEW_TOAST = "SHOW_NEW_TOAST";
var TOGGLE_LOADER = exports.TOGGLE_LOADER = "TOGGLE_LOADER";
var SHOW_LOADER = exports.SHOW_LOADER = "SHOW_LOADER";
var HIDE_LOADER = exports.HIDE_LOADER = "HIDE_LOADER";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-framework/ui-redux/screen-configuration/actionTypes.js
// module id = ../lib/egov-ui-framework/ui-redux/screen-configuration/actionTypes.js
// module chunks = 504